/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdMailLabelsLabel } from './GetCharactersCharacterIdMailLabelsLabel';
import {
    GetCharactersCharacterIdMailLabelsLabelFromJSON,
    GetCharactersCharacterIdMailLabelsLabelFromJSONTyped,
    GetCharactersCharacterIdMailLabelsLabelToJSON,
    GetCharactersCharacterIdMailLabelsLabelToJSONTyped,
} from './GetCharactersCharacterIdMailLabelsLabel';

/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdMailLabelsOk
 */
export interface GetCharactersCharacterIdMailLabelsOk {
    /**
     * labels array
     * @type {Array<GetCharactersCharacterIdMailLabelsLabel>}
     * @memberof GetCharactersCharacterIdMailLabelsOk
     */
    labels?: Array<GetCharactersCharacterIdMailLabelsLabel>;
    /**
     * total_unread_count integer
     * @type {number}
     * @memberof GetCharactersCharacterIdMailLabelsOk
     */
    totalUnreadCount?: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdMailLabelsOk interface.
 */
export function instanceOfGetCharactersCharacterIdMailLabelsOk(value: object): value is GetCharactersCharacterIdMailLabelsOk {
    return true;
}

export function GetCharactersCharacterIdMailLabelsOkFromJSON(json: any): GetCharactersCharacterIdMailLabelsOk {
    return GetCharactersCharacterIdMailLabelsOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdMailLabelsOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdMailLabelsOk {
    if (json == null) {
        return json;
    }
    return {
        
        'labels': json['labels'] == null ? undefined : ((json['labels'] as Array<any>).map(GetCharactersCharacterIdMailLabelsLabelFromJSON)),
        'totalUnreadCount': json['total_unread_count'] == null ? undefined : json['total_unread_count'],
    };
}

export function GetCharactersCharacterIdMailLabelsOkToJSON(json: any): GetCharactersCharacterIdMailLabelsOk {
    return GetCharactersCharacterIdMailLabelsOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdMailLabelsOkToJSONTyped(value?: GetCharactersCharacterIdMailLabelsOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'labels': value['labels'] == null ? undefined : ((value['labels'] as Array<any>).map(GetCharactersCharacterIdMailLabelsLabelToJSON)),
        'total_unread_count': value['totalUnreadCount'],
    };
}

